<template>
  <a-table
    :columns="columns"
    :dataSource="dataSource"
    class="times-of-success"
    :pagination="false"
    @change="onChange"
  ></a-table>
  <div class="table-pagination">
    <a-pagination
      @change="fetchData"
      v-model:current="pagination.current"
      :total="pagination.total"
      v-model:pageSize="pagination.pageSize"
      :pageSizeOptions="pagination.pageSizeOptions"
      size="small"
      show-less-items
      show-quick-jumper
      :showSizeChanger="false"
    />
  </div>
</template>

<script>
  const COLUMNS = [
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'Apply',
      sorter: true,
      dataIndex: 'applies',
    },
    {
      title: 'Success',
      sorter: true,
      dataIndex: 'success',
    },
    {
      title: 'Rate',
      sorter: true,
      dataIndex: 'rate',
    },
    {
      title: 'Entry Session',
      sorter: true,
      dataIndex: 'entry_session',
    },
  ]

  export default {
    name: 'TimesOfSuccessTable',
    props: {
      dataSource: {
        type: Array,
        default: () => {
          return []
        },
      },
      total: {
        type: Number,
      },
    },
    watch: {
      total: {
        handler(val) {
          this.pagination = { ...this.pagination, total: val }
        },
      },
    },
    data() {
      return {
        columns: COLUMNS,
        field: 'create_time',
        order: 'asc',
        pagination: {
          total: 0,
          current: 1,
          pageSize: 5,
        },
      }
    },
    methods: {
      fetchData() {
        this.$emit('change', {
          pagination: this.pagination,
          sortBy: this.field + '|' + this.order,
        })
      },
      onChange(pagination, filters, sorter) {
        if (sorter.order === 'ascend') {
          this.order = 'asc'
        }
        if (sorter.order === 'descend') {
          this.order = 'desc'
        }
        if (sorter.field === 'entry_session') {
          this.field = 'create_time'
        } else {
          this.field = sorter.field
        }
        this.$emit('change', {
          pagination: this.pagination,
          sortBy: sorter.order ? this.field + '|' + this.order : undefined,
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .times-of-success {
    margin-top: 28px;
    min-height: 324px;
  }
  /deep/ .ant-table-cell {
    border: none;
  }

  /deep/ .ant-table-thead .ant-table-cell {
    background-color: #d9bd8c4d;

    &::before {
      display: none;
    }
  }

  .table-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 22px;
  }
</style>
